import React, { useEffect, useState } from 'react'

import Flex from '../../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../../components/dashboard/DashboardInput'
import { SingleSelect } from '../../../../../../components/SelectDropdown'
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup'

import { DateTimeInput } from '../../../../../../components/DateTimeInput'
import { Button } from '../../../../../../components/Button'

const EducationalBackgroundForm = ({
  educationalBackground,
  onChange,
  showForm,
  onClose,
  onAddEducationalBackground,
  isEdit,
  educationalLevelList,
  fieldErrors,
}) => {
  const [educationLevel, setEducationalLevel] = useState(null)

  useEffect(() => {
    if (educationalBackground?.educationLevel) {
      const selectedLevel = educationalLevelList.find(
        (level) =>
          level.label === educationalBackground?.educationLevel ||
          level.label === educationalBackground?.educationLevel.label
      )
      setEducationalLevel(selectedLevel)
    }
  }, [educationalBackground?.educationLevel])

  return (
    <>
      {showForm && (
        <>
          <Flex gap="1rem">
            <SingleSelect
              title="Level of Education *"
              options={educationalLevelList}
              selected={educationLevel}
              placeholder="Select Level of Education"
              onChange={(e) => onChange('educationLevel', e)}
              wrapperClass={fieldErrors?.educationLevel && 'error'}
              subText={fieldErrors?.educationLevel}
            />
            <DashboardInput
              name="fieldOfStudy"
              label="Field of Study *"
              placeholder="Enter Field of Study"
              type="text"
              height="2.5rem"
              value={educationalBackground?.fieldOfStudy}
              errorMessage={fieldErrors?.fieldOfStudy}
              handleChange={(e) => onChange('fieldOfStudy', e.target.value)}
            />
          </Flex>
          <Flex gap="1rem">
            <DashboardInput
              name="school"
              label="School *"
              placeholder="Enter School"
              type="text"
              height="2.5rem"
              value={educationalBackground?.school}
              errorMessage={fieldErrors?.school}
              handleChange={(e) => onChange('school', e.target.value)}
            />
            <DashboardInput
              name="schoolLocation"
              label="School Location *"
              placeholder="Enter School Location"
              type="text"
              height="2.5rem"
              value={educationalBackground?.schoolLocation}
              errorMessage={fieldErrors?.schoolLocation}
              handleChange={(e) => onChange('schoolLocation', e.target.value)}
            />
          </Flex>
          <Flex>
            <RadioButtonGroup
              title="Current Status"
              name="currentStatus"
              list={[
                {
                  value: 'Graduated',
                  label: 'Graduated',
                },
                {
                  value: 'Currently Enrolled',
                  label: 'Currently Enrolled',
                },
              ]}
              selected={educationalBackground?.currentStatus || 'Graduated'}
              onChange={(value) => onChange('currentStatus', value)}
            />
          </Flex>
          <Flex gap="1rem">
            <DateTimeInput
              title="Date From"
              value={
                educationalBackground?.from
                  ? new Date(educationalBackground.from)
                  : null
              }
              onChange={(date) => onChange('from', date)}
              dateFormat="MMMM dd, yyyy"
              placeholderText="MM/YYYY"
              showYearDropdown
              scrollableYearDropdown
              wrapperClass={fieldErrors?.from && 'error'}
              subText={fieldErrors?.from}
            />

            <DateTimeInput
              title="Date To"
              value={
                educationalBackground?.to
                  ? new Date(educationalBackground.to)
                  : null
              }
              onChange={(date) => onChange('to', date)}
              dateFormat="MMMM dd, yyyy"
              placeholderText="MM/YYYY"
              showYearDropdown
              scrollableYearDropdown
              wrapperClass={fieldErrors?.to && 'error'}
              subText={fieldErrors?.to}
            />
          </Flex>
        </>
      )}
      <Flex margin="1rem 0 0 0" gap="1rem">
        <Button
          fontSize="0.875rem"
          height="35px"
          bgColor="#41ba80"
          width="50%"
          handleClick={onAddEducationalBackground}
        >
          {showForm
            ? isEdit
              ? 'Update'
              : 'Save'
            : 'Add Educational Background'}
        </Button>
        {showForm && (
          <Button
            fontSize="0.875rem"
            height="35px"
            bgColor="#dc2929"
            width="50%"
            handleClick={onClose}
          >
            Close
          </Button>
        )}
      </Flex>
    </>
  )
}

export default EducationalBackgroundForm
